class Extranet.Collections.ContactRoles extends Backbone.Collection

  model: Extranet.Models.GenericModel
  url: '/v2/getaways/extranet/contact_roles'